export enum CalendarActions {
  fetchEvents = '[Calendar]: fetch events',
  fetchEventsSuccess = '[Calendar]: fetch events success',
  fetchEventsFailure = '[Calendar]: fetch events failure',

  fetchUnscheduledEvents = '[Calendar]: fetch unscheduled events',
  fetchUnscheduledEventsSuccess = '[Calendar]: fetch unscheduled events success',
  fetchUnscheduledEventsFailure = '[Calendar]: fetch unscheduled events failure',

  fetchOrgans = '[Calendar]: fetch organs',
  fetchOrgansSuccess = '[Calendar]: fetch organs success',
  fetchOrgansFailure = '[Calendar]: fetch organs failure',

  fetchNewEventOrgans = '[Calendar]: fetch new event organs',
  fetchNewEventOrgansSuccess = '[Calendar]: fetch new event organs success',
  fetchNewEventOrgansFailure = '[Calendar]: fetch new event organs failure',

  updateSelectedOrgans = '[Calendar]: update selected organs',
  updateSelectedOrgansSuccess = '[Calendar]: update selected organs success',
  updateSelectedOrgansFailure = '[Calendar]: update selected organs failure',

  addEvent = '[Calendar]: add event',
  addEventSuccess = '[Calendar]: add event success',
  addEventFailure = '[Calendar]: add event failure',

  removeEvents = '[Calendar]:remove events',
  removeEventsSuccess = '[Calendar]:remove events success',
  removeEventsFailure = '[Calendar]:remove events failure',

  fetchUserCanCreateEventMeeting = '[Calendar]: fetch user can create event',
  fetchUserCanCreateEventSuccess = '[Calendar]: fetch user can create event success',
  fetchUserCanCreateEventFailure = '[Calendar]: fetch user can create event failure',

  fetchUserCanSeeUnscheduledEvents = '[Calendar]: fetch user can see unschedulded events',
  fetchUserCanSeeUnscheduledEventsSuccess = '[Calendar]: fetch user can see unschedulded events success',
  fetchUserCanSeeUnscheduledEventsFailure = '[Calendar]: fetch user can see unschedulded events failure',

  fetchNewEventCanHaveASecondMeetingDate = '[Calendar]: fetch new event can have a second meeting date',
  fetchNewEventCanHaveASecondMeetingDateSuccess = '[Calendar]: fetch new event can have a second meeting date success',
  fetchNewEventCanHaveASecondMeetingDateFailure = '[Calendar]: fetch new event can have a second meeting date failure'
}

export enum MeetingVotingLetterTypes {
  'YESNO' = 'YESNO',
  'CANDIDATES' = 'CANDIDATES'
}

export enum MeetingVotingLetterVisibility {
  'PUBLIC' = 'PUBLIC',
  'PRIVATE' = 'PRIVATE'
}
